import React, { useEffect } from 'react';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { Outlet } from 'react-router-dom';
import { PrivateRoutesContainer } from 'components/private-routes-container/private-routes-container.component';
import { useGetAppInitDetails } from 'hooks/queries/use-get-app-init-details.hook';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { ErrorState } from 'components/error-state/error-state.component';
import { ERROR_TYPES } from 'hooks/use-error-content/use-error-content.hook';
import SubtleErrorIcon from 'assets/error-subtle-icon.svg';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

const AmplarAuthSessionContent = () => {
  const {
    data,
    isError: isAppInitError,
    error: appInitError,
    isLoading: isAppInitLoading,
  } = useGetAppInitDetails();

  const isIneligible = data?.eligible === false;

  useEffect(() => {
    if (isIneligible) {
      StandaloneAuth.client.logout({
        federated: true,
        returnTo: `${window.location.origin}/?user_ineligible`,
      });
    }
  }, [isIneligible]);

  if (isAppInitLoading || isIneligible) return <LoadingIndicator />;

  if (isAppInitError) {
    return (
      <ErrorState
        isFullPage
        error={appInitError}
        imageSrc={SubtleErrorIcon}
        buttonAction={() =>
          StandaloneAuth.client.logout({
            federated: true,
            returnTo: window.location.origin,
          })
        }
        errorType={ERROR_TYPES.API_ERROR}
        buttonPriority="secondary"
      />
    );
  }

  return (
    <PrivateRoutesContainer>
      <Outlet />
    </PrivateRoutesContainer>
  );
};

export const AuthSessionContent = () => {
  const { systemId } = usePatientPortalContext();

  if (systemId === PATIENT_PORTAL_SYSTEM_IDS.AMPLAR) {
    return <AmplarAuthSessionContent />;
  }

  return (
    <PrivateRoutesContainer>
      <Outlet />
    </PrivateRoutesContainer>
  );
};
